import React, { useState } from "react";
import "./FeeStructureStyles.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

// --- SVG Icon Components ---
const GraduationCapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" className="fra-icon-svg">
    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM3.47 9L12 4.35 20.53 9 12 13.65 3.47 9z"/>
    <path d="M7 14.32V17c0 2.3 4.14 3.5 8 3.5s8-1.2 8-3.5v-2.68l-8 4.36-8-4.36z"/>
  </svg>
);

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

const PdfDocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" className="fra-icon-svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
    <path d="M8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"/>
  </svg>
);

// Map of icons corresponding exactly to each card row item in your design
const CardIconMap = {
  1: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
      <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"/>
    </svg>
  ),
  2: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/>
      <line x1="9" y1="22" x2="9" y2="16"/>
      <line x1="15" y1="22" x2="15" y2="16"/>
      <line x1="9" y1="16" x2="15" y2="16"/>
      <path d="M8 6h2v2H8V6zm6 0h2v2h-2V6zm-6 4h2v2H8v-2zm6 0h2v2h-2v-2z"/>
    </svg>
  ),
  3: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19h16v2H4zM19 5H5c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"/>
      <path d="M12 5V3"/>
    </svg>
  )
};

// --- Static Data ---
const FEE_DATA = {
  english: {
    pageTitle: "FRA – Fee Structure",
    subTitle: "Final Fees for Working Professional M.C.A for the AY 2026–27",
    lblAmount: "Fee Amount",
    lblTotal: "Total Fees",
    columns: ["Sr. No.", "Particulars", "Fees (₹)", "Total Fees (₹)"],
    rows: [
      { id: 1, desc: "Tuition Fees", fee: "72,727", total: "80,000" },
      { id: 2, desc: "Development Fees", fee: "7,273", total: "" },
      { id: 3, desc: "Management / Institute Seat Fees", fee: "80,000", total: "80,000" },
      { id: 4, desc: "NRI Seat Fees", fee: "Not Applicable", total: "Not Applicable" },
      { id: 5, desc: "Against NRI Seat Fees", fee: "Not Applicable", total: "Not Applicable" },
      { id: 6, desc: "Caution Money / Deposit (Refundable)", fee: "3,000", total: "3,000" },
    ],
    noteText:
      "Note: Fees are as approved by FRA for AY 2026–27. Caution Fees are refundable as per the applicable institute rules and regulations.",
    downloadText: "Download FRA Approval Letter (PDF)",
  },

  marathi: {
    pageTitle: "FRA – Fee Structure",
    subTitle: "कार्यरत व्यावसायिक एम.सी.ए. साठी अंतिम शुल्क (शैक्षणिक वर्ष २०२६–२७)",
    lblAmount: "रक्कम",
    lblTotal: "एकूण शुल्क",
    columns: ["क्रमांक", "तपशील", "शुल्क (₹)", "एकूण शुल्क (₹)"],
    rows: [
      { id: "१", desc: "शिक्षण शुल्क", fee: "७२,७२७", total: "८०,०००" },
      { id: "२", desc: "विकास शुल्क", fee: "७,२७३", total: "" },
      { id: "३", desc: "मॅनेजमेंट / इन्स्टिट्यूट सीट शुल्क", fee: "८०,०००", total: "८०,०००" },
      { id: "४", desc: "एन.आर.आय. सीट शुल्क", fee: "लागू नाही", total: "लागू नाही" },
      { id: "५", desc: "अगेंस्ट एन.आर.आय. सीट शुल्क", fee: "लागू नाही", total: "लागू नाही" },
      { id: "६", desc: "सुरक्षा जमा शुल्क (परत करण्यायोग्य)", fee: "३,०००/-", total: "३,०००/-" },
    ],
    noteText:
      "टीप: शैक्षणिक वर्ष २०२६–२७ साठी FRA ने मंजूर केलेले शुल्क. सुरक्षा जमा शुल्क लागू नियमांनुसार परत करण्यायोग्य आहे.",
    downloadText: "FRA मान्यता पत्र डाउनलोड करा (PDF)",
  },

  hindi: {
    pageTitle: "FRA – Fee Structure",
    subTitle: "कार्यरत पेशेवर एम.सी.ए. के लिए अंतिम शुल्क (शैक्षणिक वर्ष २०२६–२७)",
    lblAmount: "राशि",
    lblTotal: "कुल शुल्क",
    columns: ["क्रमांक", "विवरण", "शुल्क (₹)", "कुल शुल्क (₹)"],
    rows: [
      { id: "१", desc: "शिक्षण शुल्क", fee: "७२,७२७", total: "८०,०००" },
      { id: "२", desc: "विकास शुल्क", fee: "७,२७३", total: "" },
      { id: "३", desc: "मॅनेजमेंट / इन्स्टिट्यूट सीट शुल्क", fee: "८०,०००", total: "८०,०००" },
      { id: "४", desc: "एन.आर.आय. सीट शुल्क", fee: "लागू नहीं", total: "लागू नहीं" },
      { id: "५", desc: "अगेंस्ट एन.आर.आय. सीट शुल्क", fee: "लागू नहीं", total: "लागू नहीं" },
      { id: "६", desc: "सुरक्षा जमा शुल्क (प्रतिदेय शुल्क)", fee: "३,०००/-", total: "३,०००/-" },
    ],
    noteText:
      "नोट: शैक्षणिक वर्ष २०२६–२७ के लिए FRA द्वारा अनुमोदित शुल्क। सुरक्षा जमा शुल्क लागू नियमों के अनुसार प्रतिदेय है।",
    downloadText: "FRA स्वीकृति पत्र डाउनलोड करें (PDF)",
  },
};

const Wpmca = () => {
  const [activeTab, setActiveTab] = useState("english");
  const currentContent = FEE_DATA[activeTab];

  // Utility to handle prefix rendering for monetary figures safely
  const formatCurrencyValue = (val) => {
    if (!val) return "—";
    if (val === "Not Applicable" || val === "NA" || val === "—" || val.includes("लागू") || val.includes("शामिल") || val.includes("समाविष्ट")) {
      return val;
    }
    // Added '५' to check since fees start with 50,000
    return val.startsWith("₹") || val.startsWith("१") || val.startsWith("२") || val.startsWith("३") || val.startsWith("५") ? val : `₹${val}`;
  };

  return (
    <>
      <Navbar />
       <PageHeader
            title="Working Professional M.C.A"
            crumbs={[
              { label: "Home", href: "/" },
              { label: "Working Professional M.C.A" },
            ]}
          />

      <div className="fra-page-wrapper">
        <div className="fra-container">

          {/* Academic Year Banner with Icon */}
          <div className="fra-ay-banner-wrapper">
            <div className="fra-ay-banner">
              <GraduationCapIcon />
              <span>Academic Year: 2026–27</span>
            </div>
          </div>

          {/* Languages Selector Tabs - Uses unified classes for scrolling */}
          <div className="fra-tabs-wrapper">
            {['english', 'marathi', 'hindi'].map((lang) => (
              <button 
                key={lang}
                className={`fra-tab-btn ${activeTab === lang ? 'active' : ''}`}
                onClick={() => setActiveTab(lang)}
              >
                {lang.charAt(0).toUpperCase() + lang.slice(1)}
              </button>
            ))}
          </div>

          {/* Main Card */}
          <div className="fra-main-surface-card">
            <div className="fra-surface-card-header">
              <div className="fra-surface-card-title">
                {currentContent.subTitle}
              </div>
            </div>
            
            {/* Desktop View: Pure Clean Table */}
            <div className="fra-table-desktop-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>{currentContent.columns[0]}</th>
                    <th>{currentContent.columns[1]}</th>
                    <th>{currentContent.columns[2]}</th>
                    <th>{currentContent.columns[3]}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentContent.rows.map((row, index) => {
                    const hasTotal = row.total !== undefined && row.total !== "";
                    const nextRow = currentContent.rows[index + 1];
                    const mergeTotalDown = hasTotal && nextRow && nextRow.total === "";
                    const omitTotalCell = !hasTotal && index > 0 && currentContent.rows[index - 1].total !== "" && currentContent.rows[index - 1].total !== undefined;

                    return (
                      <tr key={index}>
                        <td>{row.id}</td>
                        <td>{row.desc}</td>
                        <td style={{ fontWeight: 'bold' }}>{row.fee}</td>
                        {mergeTotalDown ? (
                          <td rowSpan="2">{row.total}</td>
                        ) : omitTotalCell ? null : (
                          <td>{row.total}</td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Mobile View: Dynamic Card list */}
            <div className="fra-cards-mobile-stack">
              {currentContent.rows.map((row, index) => (
                <div key={index} className="fra-mobile-data-card" style={row.isTotal ? { backgroundColor: '#f8fafc', borderColor: '#e2e8f0' } : {}}>
                  
                  <div className="fra-mobile-card-aside">
                    <div className="fra-mobile-card-index">{row.id || "∑"}</div>
                    <div className="fra-mobile-card-icon-bubble">
                      {/* Uses index + 1 to grab correct icon */}
                      {CardIconMap[index + 1] || <GraduationCapIcon />}
                    </div>
                  </div>
                  
                  <div className="fra-mobile-card-body">
                    <h3 className="fra-mobile-card-heading" style={row.isTotal ? { fontSize: '1.05rem', color: '#0f172a' } : {}}>
                      {row.desc}
                    </h3>
                    
                    <div className="fra-mobile-card-meta-row">
                      <div className="fra-meta-data-chunk">
                        <span className="fra-meta-chunk-label">{currentContent.lblAmount}</span>
                        <span className="fra-meta-chunk-value value-dark-bold" style={row.isTotal ? { fontSize: '1rem', color: '#2563eb' } : {}}>
                          {formatCurrencyValue(row.fee)}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              ))}
            </div>

            {/* Structured Bottom Footnote */}
            <div className="fra-mobile-legal-footnote">
              <div className="fra-footnote-icon-holder">
                <InfoIcon />
              </div>
              <div className="fra-footnote-text-holder">
                {currentContent.noteText}
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Wpmca;